import { createFileRoute } from '@tanstack/react-router';
import { ReceiptText } from 'lucide-react';
import { SelectionPlaceholder } from '@/components/molecules';

export const Route = createFileRoute('/_dashboard/dashboard/receipts/')({
  component: ReceiptsIndexPage,
});

function ReceiptsIndexPage() {
  return (
    <SelectionPlaceholder
      icon={ReceiptText}
      title="Select a receipt"
      iconClassName="h-10 w-10 opacity-30"
      className="flex h-full flex-col items-center justify-center gap-3 text-muted-foreground"
    />
  );
}
